var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomOutIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "26px",
    viewBox: "0 0 45 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zoom Out") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-120.000000, -69.000000)",
    stroke: "#0B1319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Zoom-Out",
    transform: "translate(120.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 0.75,
    width: 43.5,
    height: 41.5,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-zoom-1498929",
    transform: "translate(22.854486, 21.323040) rotate(-360.000000) translate(-22.854486, -21.323040) translate(10.354486, 11.000000)",
    fill: "#0B1319",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37396672,18.7476848 C6.88763353,18.7476848 4.50364073,17.7599964 2.74562318,16.0023103 C0.987605621,14.2442927 0,11.8599685 0,9.37396672 C0,6.88763353 0.987605621,4.50364073 2.74562318,2.74562318 C4.50364073,0.987605621 6.88763353,0 9.37396672,0 C11.8599685,0 14.2442927,0.987605621 16.0023103,2.74562318 C17.7603278,4.50364073 18.7479334,6.88763353 18.7479334,9.37396672 C18.7440491,11.8586426 17.7551901,14.2410609 15.9980841,15.9981669 C14.240978,17.755273 11.8589741,18.7441216 9.37388386,18.7476848 L9.37396672,18.7476848 Z M9.37396672,1.38702323 C7.25697052,1.38702323 5.22673577,2.22795475 3.729997,3.72510786 C2.23325822,5.22184663 1.39224384,7.25208138 1.39224384,9.36874612 C1.39224384,11.4857423 2.23317535,13.5159771 3.729997,15.0127158 C5.22681864,16.5094546 7.25697052,17.350469 9.37396672,17.350469 C11.4906315,17.350469 13.5208662,16.5095375 15.0179365,15.0127158 C16.5146752,13.5159771 17.3556896,11.4857423 17.3556896,9.36874612 C17.3531,7.25274431 16.5114434,5.22408404 15.0150361,3.72767673 C13.5188774,2.23118655 11.4899685,1.3895921 9.37396672,1.38702323 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3024071,20.6460803 C24.1554513,20.645755 24.0123736,20.5984949 23.893899,20.5114202 L16.1302814,14.8454079 C15.9742599,14.7392391 15.8677596,14.574152 15.835715,14.3883482 C15.8036688,14.2022213 15.8483389,14.0112383 15.9596919,13.8587801 C16.0710482,13.7063219 16.2396903,13.6056472 16.4267868,13.5800745 C16.6138833,13.5545026 16.8032503,13.6056463 16.9514989,13.7221743 L24.7153651,19.3885181 C24.958463,19.566549 25.0591295,19.8808624 24.965258,20.1670095 C24.8710634,20.4534798 24.6036857,20.6467333 24.3023242,20.6460803 L24.3024071,20.6460803 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4576389,9.79633842 L5.31822064,9.79633842 C4.93399249,9.79633842 4.62227274,9.48461866 4.62227274,9.10039052 C4.62227274,8.7158392 4.93399249,8.40411944 5.31822064,8.40411944 L13.4576389,8.40411944 C13.8421902,8.40411944 14.15391,8.7158392 14.15391,9.10039052 C14.15391,9.48461866 13.8421902,9.79633842 13.4576389,9.79633842 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutIcon);
export default __webpack_public_path__ + "static/media/zoom-out-icon.d494b41b0a296d111da8129f2b31f342.svg";
export { ForwardRef as ReactComponent };